import { Blog } from '~/commons/interfaces/models/content/blog/Blog'
import { Category } from '~/commons/interfaces/models/content/category/Category'

/**
 * @alpha
 */
export function getBlogMainCategory(blog: Blog): Category | undefined {
  return blog.blogCategories?.[0]
}
